export interface UserPermissions {
  user: {
    id: string;
    email: string;
    name: string;
    picture?: string;
    is_admin: boolean;
  };
  partner_permissions: PartnerPermission[];
  tenant_permissions: TenantPermission[];
}

export interface PartnerPermission {
  partner_id: string;
  partner_name: string;
  role: 'viewer' | 'operator' | 'admin';
}

export interface TenantPermission {
  tenant_id: string;
  tenant_name: string;
  partner_id: string;
  partner_name: string;
  role: 'viewer' | 'operator' | 'admin';
}

export interface Permission {
  resource_type: 'partner' | 'tenant';
  resource_id: string;
  resource_name: string;
  role: 'viewer' | 'operator' | 'admin';
}

export type Role = 'viewer' | 'operator' | 'admin';

export const ROLE_HIERARCHY: Record<Role, number> = {
  viewer: 1,
  operator: 2,
  admin: 3,
};

export const PERMISSIONS: Record<Role, string[]> = {
  viewer: [
    'view_dashboard',
    'view_tenant_data',
    'view_partner_data',
    'view_bots',
    'view_stats',
    'view_operations',
    'view_runbooks',
    'view_assets'
  ],
  operator: [
    'view_dashboard',
    'view_tenant_data',
    'view_partner_data',
    'view_bots',
    'view_stats',
    'view_operations',
    'view_admin_panel',
    'view_audit_log',
    'access_operations',
    'create_bots',
    'control_bots',
    'manage_attack',
    'view_operational_errors',
    'view_runbooks',
    'view_assets'
  ],
  admin: [
    'view_dashboard',
    'view_tenant_data',
    'view_partner_data',
    'view_bots',
    'view_stats',
    'view_operations',
    'view_admin_panel',
    'access_operations',
    'create_bots',
    'control_bots',
    'manage_attack',
    'view_operational_errors',
    'manage_tenant_users',
    'invite_tenant_users',
    'delete_tenant_users',
    'manage_tenant_settings',
    'manage_tenants',
    'create_tenants',
    'update_tenants',
    'delete_tenants',
    'access_maintenance',
    'access_partners',
    'manage_allow_list',
    'request_allow_list_entries',
    'view_audit_log',
    'view_runbooks',
    'manage_runbooks',
    'view_assets'
  ]
};

export function hasPermission(userRole: Role, requiredPermission: string): boolean {
  return PERMISSIONS[userRole]?.includes(requiredPermission) || false;
}

export function hasRoleAccess(userRole: Role, requiredRole: Role): boolean {
  return ROLE_HIERARCHY[userRole] >= ROLE_HIERARCHY[requiredRole];
}

export interface Invitation {
  id: string;
  email: string;
  role: string;
  invited_by: string;
  created_at: string;
  expires_at: string;
  is_accepted: boolean;
  partner_id?: string;
  tenant_id?: string;
}